import React, { useState, useEffect } from 'react';
import { set, z } from 'zod';
import { motion } from 'framer-motion';
import 'react-toastify/dist/ReactToastify.css';
import { useLocation, useNavigate } from 'react-router';
import { toast } from 'react-toastify';
import GoogleIcon from '../google.png';
import { useDispatch, useSelector } from 'react-redux';
import { setIsLoggedIn } from '../redux/slices/authSlice';
import { fetchGoogleAuthUrlThunk, loginUserThunk, registerUserThunk, sendOtpThunk, verifyOtpThunk } from '../thunks/thunks';

const userDatabase = [
    {
        email: 'dakshgpt12@gmail.com',
        password: '123456'
    }
];

const registerSchema = z.object({
    name: z.string().min(1, 'Name is required'),
    email: z.string().email('Invalid email format'),
    password: z.string().min(6, 'Password must be at least 6 characters long'),
    confirmPassword: z.string().min(6, 'Confirm password must be at least 6 characters long'),
}).refine((data) => data.password === data.confirmPassword, {
    message: "Passwords don't match",
    path: ['confirmPassword'],
});

const Register = () => {
    const isLoggedIn = useSelector((state) => state.auth.isLoggedIn);
    const navigate = useNavigate();
    const location = useLocation();
    
    useEffect(() => {
        if (isLoggedIn && location.pathname === '/register') {
          toast.success('You are already logged in!');
          navigate('/');
        }
      }, [isLoggedIn, location.pathname, navigate]);
    
    const [isLogin, setIsLogin] = useState(false);
    const [formData, setFormData] = useState({
        name: '',
        email: '',
        phone: '',
        password: '',
        confirmPassword:'',
    });
    const [isOtpStep, setIsOtpStep] = useState(false); // Toggle OTP step
    const [otp, setOtp] = useState("");
    const [timer, setTimer] = useState(60); // Resend OTP timer
    const dispatch = useDispatch();
    const [errors, setErrors] = useState({});


    const {isLoading, error, otpSent} = useSelector((state) => state.auth);
    
    const [temp,setTemp] = useState(0);

    const handleChange = (e) => {
        setFormData({
            ...formData,
            [e.target.name]: e.target.value
        });
    };

    const handleOtpChange = (e) => {
        setOtp(e.target.value);
    };

    const dummyRegister = (data) => {
        dispatch(registerUserThunk(data))
        .unwrap()
        .then(() => handleSendOtp())
        .catch((err) => {
            toast.error(err.message);
        });
        
        console.log("OTP: ",temp);
    };

    const handleSubmit = (e) => {
        e.preventDefault();

        if (isLogin) {
            dispatch(loginUserThunk({email:formData.email,password:formData.password}))
            .unwrap()
            .then(() => {
                toast.success('Login successful!');
                navigate('/');
            })
            .catch((err) => {
                toast.error(err.message);
            });
            
        } else if (!isOtpStep) {
            const validation = registerSchema.safeParse(formData);
            if (!validation.success) {
                const formattedErrors = validation.error.format();
                setErrors(formattedErrors);
                return;
            }
            // const temp2 = Math.floor(Math.random()*(999999-100000+1))+100000;
            // setTemp(temp2);
            // console.log("Temppp: ",temp2);
            dummyRegister(formData);
            setErrors({});
        } else {
            // OTP validation
            const otpNumber = Number(otp);
            dispatch(verifyOtpThunk({ email: formData.email,otp:otpNumber }))
            .unwrap()
            .then(() => {
                toast.success('OTP verified successfully! Please login to continue !!');
                window.location.reload();
            })
            .catch((err) => {
                toast.error(err.message);
            });
            
        }
    };

    const toggleForm = () => {
        setIsLogin((prev) => !prev);
        setFormData({
            name: '',
            email: '',
            phone: '',
            password: '',
            confirmPassword: ''
        });
        setErrors({});
    };

    const startTimer = () => {
        setTimer(60);
        const interval = setInterval(() => {
            setTimer((prev) => {
                if (prev <= 1) {
                    clearInterval(interval);
                }
                return prev - 1;
            });
        }, 1000);
    };
    const handleForgot = () => {
        navigate('/forgot');
    };
    const handleSendOtp = () => {
        dispatch(sendOtpThunk(formData.email))
            .unwrap()
            .then(() => {
                toast.success('OTP sent successfully!');
                setIsOtpStep(true); // Move to OTP step
                startTimer(); // Start the resend OTP timer
            })
            .catch((err) => {
                toast.error(err.message);
            });

    };
    const resendOtp = () => {
        if (timer === 0) {
            handleSendOtp();
            startTimer(); // Restart the timer
        }
        console.log("temp: ",temp);
    };

    const GoogleSignInButton = ({ onClick, text }) => (
        <button
            onClick={onClick}
            className="flex items-center bg-white mt-2 shadow-md text-gray-500 rounded-lg p-2 hover:bg-gray-200 transition duration-200 w-full justify-center"
        >
            <div className="bg-white rounded-full mr-3">
                <img src={GoogleIcon} alt="Google Icon" className="h-6 w-6" />
            </div>
            <span className="text-1xl">{text}</span>
        </button>
    );

    const handleGoogleSignIn = async () => {
        try {
            const result = await dispatch(fetchGoogleAuthUrlThunk()).unwrap();
            window.location.href = result; // Redirect to Google OAuth
          } catch (error) {
            toast.error(error || 'Failed to redirect to Google login');
          }
        };
    
    
        return (
            <div className="min-h-screen flex items-center justify-center bg-[#F2B3CA] px-4 sm:px-6 lg:px-8">
                <div className="bg-white p-8 rounded-lg shadow-lg w-full max-w-sm sm:max-w-md lg:max-w-lg">
                    {!isOtpStep ? (
                        <>
                            <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-left">{isLogin ? 'Login' : 'Register'}</h2>
                            <p className="mb-6 text-gray-400 text-sm sm:text-base lg:text-lg">
                                {isLogin ? "Welcome back !!" : "Come explore the greatest inventory!"}
                            </p>
                            <motion.div
                                key={isLogin ? 'login' : 'register'}
                                initial={{ opacity: 0, y: 20 }}
                                animate={{ opacity: 1, y: 0 }}
                                exit={{ opacity: 0, y: -20 }}
                                transition={{ duration: 0.5 }}
                            >
                                <form onSubmit={handleSubmit} className="space-y-4">
                                    {!isLogin && (
                                        <div>
                                            <label className="block mb-2 text-sm font-medium text-gray-600">Name</label>
                                            <input
                                                type="text"
                                                name="name"
                                                value={formData.name}
                                                onChange={handleChange}
                                                className={`w-full p-2 border ${errors.name ? 'border-red-500' : 'border-gray-300'} rounded text-sm sm:text-base`}
                                                placeholder="Your Name"
                                            />
                                            {errors.name && <p className="text-red-500 text-xs">{errors.name._errors}</p>}
                                        </div>
                                    )}
        
                                    <div>
                                        <label className="block mb-2 text-sm font-medium text-gray-600">Email</label>
                                        <input
                                            type="email"
                                            name="email"
                                            value={formData.email}
                                            onChange={handleChange}
                                            className={`w-full p-2 border ${errors.email ? 'border-red-500' : 'border-gray-300'} rounded text-sm sm:text-base`}
                                            placeholder="Your Email"
                                        />
                                        {errors.email && <p className="text-red-500 text-xs">{errors.email._errors}</p>}
                                    </div>
        
                                    {!isLogin && (
                                        <div>
                                            <label className="block mb-2 text-sm font-medium text-gray-600">Phone</label>
                                            <input
                                                type="text"
                                                name="phone"
                                                value={formData.phone}
                                                onChange={handleChange}
                                                className={`w-full p-2 border ${errors.phone ? 'border-red-500' : 'border-gray-300'} rounded text-sm sm:text-base`}
                                                placeholder="Your Phone Number"
                                            />
                                            {errors.phone && <p className="text-red-500 text-xs">{errors.phone._errors}</p>}
                                        </div>
                                    )}
        
                                    <div>
                                        <label className="block mb-2 text-sm font-medium text-gray-600">Password</label>
                                        <input
                                            type="password"
                                            name="password"
                                            value={formData.password}
                                            onChange={handleChange}
                                            className={`w-full p-2 border ${errors.password ? 'border-red-500' : 'border-gray-300'} rounded text-sm sm:text-base`}
                                            placeholder="Your Password"
                                        />
                                        {errors.password && <p className="text-red-500 text-xs">{errors.password._errors}</p>}
                                    </div>
        
                                    {!isLogin && (
                                        <div>
                                            <label className="block mb-2 text-sm font-medium text-gray-600">Confirm Password</label>
                                            <input
                                                type="password"
                                                name="confirmPassword"
                                                value={formData.confirmPassword}
                                                onChange={handleChange}
                                                className={`w-full p-2 border ${errors.confirmPassword ? 'border-red-500' : 'border-gray-300'} rounded text-sm sm:text-base`}
                                                placeholder="Confirm Password"
                                            />
                                            {errors.confirmPassword && <p className="text-red-500 text-xs">{errors.confirmPassword._errors}</p>}
                                        </div>
                                    )}
                                    {isLogin && 
                                    <div className="text-left">
                                        <button onClick={handleForgot} className="text-blue-600 hover:underline">Forgot Password?</button>
                                    </div>
                                    }
                                    <button
                                        type="submit"
                                        className="w-full bg-black text-white p-2 rounded hover:bg-gray-600 transition duration-200 text-sm sm:text-base"
                                    >
                                        {isLogin ? 'Login' : 'Register'}
                                    </button>
                                </form>
                                <GoogleSignInButton
                                    onClick={handleGoogleSignIn}
                                    text={isLogin ? 'Login with Google' : 'Register with Google'}
                                />
                                <p className="mt-4 text-center text-sm sm:text-base">
                                    {isLogin ? "Don't have an account?" : 'Already have an account?'}{' '}
                                    <button onClick={toggleForm} className="text-blue-600 hover:underline">
                                        {isLogin ? 'Register' : 'Login'}
                                    </button>
                                </p>
                            </motion.div>
                        </>
                    ) : (
                        <>
                            <h2 className="text-2xl sm:text-3xl lg:text-4xl font-bold text-center">OTP Confirmation</h2>
                            <p className="mt-2 text-gray-600 text-sm sm:text-base lg:text-lg text-center">
                                Enter the OTP sent to your email
                            </p>
                            <form onSubmit={handleSubmit} className="space-y-4 mt-4">
                                <div>
                                    <label className="block mb-2 text-sm font-medium text-gray-600">OTP</label>
                                    <input
                                        type="text"
                                        value={otp}
                                        onChange={handleOtpChange}
                                        className="w-full p-2 border border-gray-300 rounded text-sm sm:text-base"
                                        placeholder="Enter OTP"
                                    />
                                </div>
                                <button
                                    type="submit"
                                    className="w-full bg-black text-white p-2 rounded hover:bg-gray-600 transition duration-200 text-sm sm:text-base"
                                >
                                    Verify OTP
                                </button>
                            </form>
                            <p className="mt-4 text-center text-gray-500 text-sm sm:text-base">
                                Resend OTP in{' '}
                                <span className="font-semibold text-black">{timer > 0 ? `${timer}s` : 'now'}</span>
                            </p>
                            {timer === 0 && (
                                <button
                                    onClick={resendOtp}
                                    className="mt-2 w-full bg-gray-200 text-black p-2 rounded hover:bg-gray-300 transition duration-200 text-sm sm:text-base"
                                >
                                    Resend OTP
                                </button>
                            )}
                        </>
                    )}
                </div>
            </div>
        );
        
};

export default Register;
